<template>
  <div id="cooperation">
    <!--banner-->
    <div class="swiper-container swiper-no-swiping common" id="banner">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide swiper-slide-banner"
          style="background-image: url('https://img.deepbaytech.com/fn/cooperation.jpg')"
        >
          <div class="swiper-slide-title" style="text-align: center;">
            <div style="font-size: 48px;">合作共赢</div>
            <div style="font-size: 20px;margin-top:12px">
              致力于建设合作伙伴生态体系，AI赋能，让一切皆有可能
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <!-- 整合行业解决方案，助力业务升级 -->
      <div class="cooperation-solution">
        <p class="cooperation-solution-title">整合行业解决方案，助力业务升级</p>
        <div class="cooperation-solution-list">
          <div class="cooperation-solution-li">
            <img
              class="cooperation-solution-li-img"
              src="https://img.deepbaytech.com/images2021/cost.png"
              alt=""
              style="width:96px;height:96px"
            />
            <p class="cooperation-solution-li-p1">高性价比</p>
            <p class="cooperation-solution-li-p2">
              降低人工智能基础设施成本,同时提升计算中心效率
            </p>
          </div>
          <div class="cooperation-solution-li">
            <img
              class="cooperation-solution-li-img"
              src="https://img.deepbaytech.com/images2021/initiative.png"
              alt=""
              style="width:96px;height:96px"
            />
            <p class="cooperation-solution-li-p1">高效能动</p>
            <p class="cooperation-solution-li-p2">
              整合优质资源，为企业客户赋能, 助力业务
            </p>
          </div>
          <div class="cooperation-solution-li">
            <img
              class="cooperation-solution-li-img"
              src="https://img.deepbaytech.com/images2021/service.png"
              alt=""
              style="width:96px;height:96px"
            />
            <p class="cooperation-solution-li-p1">优质服务</p>
            <p class="cooperation-solution-li-p2">
              丰富的项目落地经验，全面优质技术支持
            </p>
          </div>
        </div>
      </div>
      <!-- 联系我们 -->
      <div class="contact-us">
        <p class="contact-us-title">联系我们</p>
        <div class="contact-us-list">
          <div class="contact-us-list-li">
            <p class="contact-us-list-p1">服务咨询</p>
            <p class="contact-us-list-p2">13051739989</p>
            <img
              class="contact-us-list-img"
              src="https://img.deepbaytech.com/images2021/tel.png"
              alt=""
              style="width:30px;height:30px"
            />
            <!-- <img :src="staImg2"> -->
          </div>
          <div class="contact-us-list-li">
            <p class="contact-us-list-p1">人才招聘</p>
            <p class="contact-us-list-p2">xinweini@deepbaytech.com</p>
            <img
              class="contact-us-list-img"
              src="https://img.deepbaytech.com/images2021/email.png"
              alt=""
              style="width:30px;height:30px"
            />
            <!-- <img :src="staImg3"> -->
          </div>
          <div class="contact-us-list-li">
            <p class="contact-us-list-p1">公司地址</p>
            <p class="contact-us-list-p2">
              北京市朝阳区望京东园保利国际广场T2-3层
            </p>
            <img
              class="contact-us-list-img-four"
              src="https://img.deepbaytech.com/images2021/place.png"
              alt=""
              style="width:30px;height:30px"
            />
            <!-- <img :src="staImg4"> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 服务咨询 -->
    <Consultation class="common" />
    <!-- 尾部 -->
    <Footer class="common" />
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";
import Consultation from "./../../components/Consultation/Consultation";
import Footer from "./../../components/Footer/Footer";
export default {
  name: "Cooperation",
  components: {
    Consultation,
    Footer,
  },
  data() {
    return {
      staImg1: "",
      staImg2: "",
      staImg3: "",
      staImg4: "",
    };
  },
  mounted() {
    new Swiper("#banner", {
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
  //     methods:{
  //         // changeImageSrc(){
  //         //      let urlTemp = "https://img.deepbaytech.com/images/product_icon_function@2x.png";
  //         //      this.staImg1 = require("@/"+urlTemp)
  //         // }
  //     changeImageSrc (key, way) {
  //   // console.log('鼠标移入/移出')
  //   // 移入或移出时图标src 名后缀变化('_h'表示移入状态;默认状态后缀为空'')
  //            // let tempStr = way === 'hover' ? '_cost_performance@2x' : ''
  //             let urlTemp  = way === 'hover' ? "https://img.deepbaytech.com/images/product_icon_function@2x.png" : "https://img.deepbaytech.com/images/product_icon_cost_performance@2x.png";
  //             switch (key) {
  //                 case 1:
  //                 this.staImg1 = require(urlTemp )
  //                 console.log(this.staImg1)
  //                // this.staImg1 = require(`https://img.deepbaytech.com/images/product_icon${tempStr}.png`)
  //               //  this.staImg1 = way === 'hover' ? require(`https://img.deepbaytech.com/images/product_icon_function@2x.png`) : require(`https://img.deepbaytech.com/images/product_icon_cost_performance@2x.png`)
  //                 break
  //                 case 2:
  //                     this.staImg2 = require(urlTemp )
  //                 // this.staImg2 = require(`@/../static/img/logo_home_standard2${tempStr}.png`)
  //                // this.staImg2 =  way === 'hover' ? require(`https://img.deepbaytech.com/images/product_icon_function@2x.png`) : require(`https://img.deepbaytech.com/images/product_icon_cost_performance@2x.png`)
  //                 break
  //                 //可以继续添加
  //                 case 3:
  //                     this.staImg3 = require(urlTemp)
  //                 // this.staImg2 = require(`@/../static/img/logo_home_standard2${tempStr}.png`)
  //                // this.staImg3 =  way === 'hover' ? require(`https://img.deepbaytech.com/images/product_icon_function@2x.png`) : require(`https://img.deepbaytech.com/images/product_icon_cost_performance@2x.png`)
  //                 break
  //                 case 4:
  //                     this.staImg4 = require(urlTemp)
  //                 // this.staImg2 = require(`@/../static/img/logo_home_standard2${tempStr}.png`)
  //                 //this.staImg4 =  way === 'hover' ? require(`https://img.deepbaytech.com/images/product_icon_function@2x.png`) : require(`https://img.deepbaytech.com/images/product_icon_cost_performance@2x.png`)
  //                 break
  //             }
  //         },

  //     }
};
</script>
<style scoped>
.common {
  min-width: 1180px;
}
.swiper-container {
  height: 480px;
}
.swiper-slide-banner {
  width: 100%;
  height: 480px !important;
}
.swiper-slide {
  position: relative;
  background-size: cover;
}
.swiper-slide-title {
  color: #fff;
  width: 1180px;
  margin: 0 auto;
  padding-top: 170px;
}
.container {
  width: 100%;
  min-width: 1180px;
  margin-bottom: 80px;
}
.cooperation-solution,
.contact-us {
  width: 1180px;
  margin: 80px auto;
}
.cooperation-solution-title,
.contact-us-title {
  font-size: 32px;
  text-align: center;
}
.cooperation-solution-list,
.contact-us-list {
  display: flex;
  justify-content: space-between;
  margin-top: 64px;
}
.cooperation-solution-li {
  width: 380px;
  height: 313px;
  text-align: center;
  border: 1px solid rgba(234, 234, 234, 1);
}
.cooperation-solution-li-img {
  margin-top: 48px;
}
.cooperation-solution-li-p1 {
  margin-top: 22px;
  font-size: 24px;
  color: #333333;
}
.cooperation-solution-li-p2 {
  width: 220px;
  margin: 12px auto;
  margin-top: 12px;
  font-size: 14px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.cooperation-solution-li:hover {
  border: 1px solid #77ba00;
}
.contact-us-list-li {
  width: 280px;
  height: 240px;
  background: #f6f8fb;
}
.contact-us-list-p1 {
  margin: 32px 20px 0 20px;
  font-size: 24px;
  color: #333333;
}
.contact-us-list-p2 {
  margin: 16px 20px 0 20px;
  font-size: 16px;
  color: #666666;
}
.contact-us-list-img {
  margin-top: 78px;
  margin-left: 221px;
}
.contact-us-list-img-four {
  margin-top: 60px;
  margin-left: 221px;
}
.contact-us-list-li:hover {
  background: #77ba00;
  color: #ffffff !important;
}
.contact-us-list-li:hover .contact-us-list-p1 {
  color: #ffffff !important;
}
.contact-us-list-li:hover .contact-us-list-p2 {
  color: #ffffff !important;
}
</style>
